export default "__VITE_ASSET__b166083c__"